import {graphql} from 'react-relay'

export const pipelineQuery = graphql`
  query PipelineRunPagePipelineQuery($locator: String!) {
    project(projectLocator: $locator) {
      ...PipelineRunHeaderFragment
    }
  }
`
